module.exports = __webpack_public_path__ + "assets/img/detail-content-img-1-fb2c9168.jpg";